import {Children, type ReactNode} from 'react';
import {type VariantProps} from 'class-variance-authority';
import {CircleCheck} from 'lucide-react';
import {cn} from '../lib/cn';
import {checkListItemVariants, checkListRootVariants} from './listVariants';

type CheckListProps = {
  children?: ReactNode;
  className?: string;
  itemClassName?: string;
} & VariantProps<typeof checkListRootVariants>;

const CheckList = ({
  children,
  className,
  itemClassName,
  size = 'default',
}: CheckListProps) => {
  const items = Children.toArray(children);

  return (
    <ul className={cn(checkListRootVariants({size}), className)} data-size={size}>
      {items.map((child, index) => (
        <li key={index} className={cn(checkListItemVariants(), itemClassName)}>
          <CircleCheck
            className="check-list-icon relative top-[2px] shrink-0"
            fill="var(--check-list-icon-color)"
            stroke="var(--check-list-icon-mark-color)"
          />
          <div className="inline-block">{child}</div>
        </li>
      ))}
    </ul>
  );
};

export {CheckList};
export type {CheckListProps};
